import * as React from "react";

import {
  MenuButtonProps,
  useMenuButton_unstable,
} from "@fluentui/react-button";

import { AppButtonProps } from "../../AppButton/next";
import { useMergedTooltipAndKeytipRef } from "../../AppButton/next/useMergedTooltipAndKeytipRef";
import { AppMenuButtonProps, AppMenuButtonState } from ".";
import { useAppMenuButtonState } from "./useAppMenuButtonState";

export const useAppMenuButton = (
  props: AppMenuButtonProps,
  ref: React.Ref<HTMLButtonElement>
): AppMenuButtonState => {
  const { disabled } = props;

  // Set useDirectClick to true for correct keytip behavior
  const mergedRefWithKeytip = useMergedTooltipAndKeytipRef(
    { ...(props as AppButtonProps), useDirectClick: true },
    ref
  );

  const menuButtonState = useMenuButton_unstable(
    {
      ...props,
      type: "button",
      disabledFocusable: disabled,
    } as MenuButtonProps,
    mergedRefWithKeytip
  );

  return useAppMenuButtonState(props, menuButtonState);
};
